<template>
    <div>
        <div v-for="(row, idx) in rows" :key="idx" class="row edit-row">
            <!-- SaaS column: everything in marking.attachments -->
            <div class="offset-4 col-4 d-flex justify-content-center py-3">
                <AttachmentCard :attachment="row.saas" @open-image="$emit('open-image', $event)"/>
            </div>

            <div v-if="attachmentColumns.length <= 1" class="col-4 d-flex justify-content-center from-mobile py-3">
                <AttachmentCard :attachment="mobileAttachmentFor(row, attachmentColumns[0])"
                                @open-image="$emit('open-image', $event)"/>
            </div>
            <div v-else class="from-mobile mobile-cells-wrapper mobile-cells-multi py-3">
                <div v-for="attachmentColumn in attachmentColumns" :key="attachmentColumn.userId"
                     class="mobile-cell has-divider">
                    <AttachmentCard :attachment="mobileAttachmentFor(row, attachmentColumn)"
                                    @open-image="$emit('open-image', $event)"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AttachmentCard from "./AttachmentCard.vue";

export default {
    name: 'MarkingAttachmentComparison',
    components: {AttachmentCard},
    props: {
        marking: {
            type: Object,
            required: true,
        },
        allAttachmentChangeLogs: {
            type: Array,
            default: () => [],
        },

        viewMode: {
            type: String,
            default: 'aggregate',
        },

        columns: {
            type: Array,
            default: () => [],
        },

        mobileLogs: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        mobileAttachmentFor(row, attachmentColumn) {

            if (!attachmentColumn) return null;
            return (row.mobile && row.mobile.userId === attachmentColumn.userId) ? row.mobile : null;
        },
        nearestMobileLogUserId(createdAt) {
            if (!createdAt) return null;

            const NEAREST_LOG_WINDOW_MS = 2 * 60 * 1000;
            const t = new Date(createdAt).getTime();
            let bestUserId = null, bestDiff = Infinity;

            for (const log of (this.mobileLogs || [])) {
                if (log.action?.platform === 'browser') continue;
                const diff = Math.abs(new Date(log.created_at).getTime() - t);
                if (diff < bestDiff) {
                    bestDiff = diff;
                    bestUserId = log.user_id ?? null;
                }
            }

            return bestDiff <= NEAREST_LOG_WINDOW_MS ? bestUserId : null;
        },
    },
    computed: {
        rows() {
            const result = [];
            const isPerUser = this.viewMode === 'per-user';

            const managedHashes = new Set(
                (this.marking?.attachments || []).map(a => a.hash).filter(Boolean)
            );

            const unreliableHashes = new Set(['error', 'missing-file']);

            for (const a of (this.marking?.attachments || [])) {
                const saas = a.is_trashed ? null : a;

                const isReliableHash = a.hash && !unreliableHashes.has(a.hash);
                const uploaderLog = isPerUser && isReliableHash && !a.uploaded_by
                    ? (this.allAttachmentChangeLogs || []).find(log => (log.attachments || []).some(img => img.hash === a.hash))
                    : null;
                const uploaderId = a.uploaded_by
                    ?? uploaderLog?.user?.id
                    ?? (isPerUser ? this.nearestMobileLogUserId(a.created_at) : null)
                    ?? null;

                const mobile = a.source !== 'saas' ? {...a, userId: isPerUser ? uploaderId : 'aggregate'} : null;
                if (!saas && !mobile) continue;
                result.push({
                    saas,
                    mobile,
                    date: a.created_at,
                });
            }

            for (const log of (this.allAttachmentChangeLogs || [])) {
                for (const img of (log.attachments || [])) {
                    if (img.hash && managedHashes.has(img.hash)) continue;
                    result.push({
                        saas: null,
                        mobile: {
                            ...img,
                            date: log.created_at,
                            userId: isPerUser ? (log.user ? log.user.id : null) : 'aggregate',
                        },
                        date: log.created_at,
                    });
                }
            }

            return result.sort((a, b) => new Date(a.date) - new Date(b.date));
        },
        attachmentColumns() {
            if (this.viewMode !== 'per-user') {
                return [{userId: 'aggregate', userName: 'Mobile added info'}];
            }

            return this.columns.map(col => ({userId: col.userId, userName: col.userName}));
        },
    },
};
</script>

<style scoped>
.mobile-cells-multi {
    display: block;
    white-space: nowrap;
    flex: 0 0 auto;
}

.mobile-cells-multi .mobile-cell {
    display: inline-block !important;
    box-sizing: border-box !important;
    width: 265px !important;
    padding: 0 8px !important;
    margin: 0 !important;
    vertical-align: top;
    white-space: normal;
}

.mobile-cell.has-divider {
    height: 100%;
    border-left: 1px solid #ccc;
}

.mobile-cell.has-divider:first-child {
    border-left: none;
}
</style>
